// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IParticipantAccountActivityMultiEmployersSummaryRecordDto } from './IParticipantAccountActivityMultiEmployersSummaryRecordDto';
import {
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IParticipantAccountActivityMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IParticipantAccountActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<IParticipantAccountActivityMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON)),
    };
}

